import { ComponentElem } from "@components/interfaces";
import PopupBase from "./PopupBase";
import LoginByEmail from "./LoginByEmail";
import FormTools from "@root/ts/FormTools";
import schema from "@schema/common/login-forget-password.json";

export default class LoginForgetPassword extends PopupBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);

    this.$root.find(".btn-cancel").on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      LoginByEmail.instance.toMe();
    });

    this.$root.find(".btn-send").on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      
      let result = FormTools.getFormData(this.$root);
      if(result.isReady)
      {
        FormTools.sendForm("common/login-forget-password", result.formData, this.$root, {schema: schema, exampleIndex: 1, autoCloseAlert: false}).then((result)=>
        {
          FormTools.handleNextUrl(result);
        }).catch(()=>
        {
          this.toMe();
        });
      }
    });
    
  }

  
}